
import React from 'react';
import { Info } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@/components/ui/popover";

interface PageInfoProps {
  title: string;
  description: string;
}

const PageInfo: React.FC<PageInfoProps> = ({ title, description }) => {
  return (
    <div className="absolute top-4 right-4 md:top-6 md:right-6">
      <Popover>
        <PopoverTrigger asChild>
          <button
            aria-label="Información de la página"
            className="rounded-full p-1.5 text-vegana-primary hover:bg-vegana-primary/10 transition-colors"
          >
            <Info className="h-5 w-5" />
          </button>
        </PopoverTrigger>
        <PopoverContent 
          className="w-80 p-4 shadow-md border border-vegana-primary/20"
          side="bottom"
          align="center"
          sideOffset={5}
        >
          <div className="space-y-2">
            <h3 className="font-medium text-vegana-primary">{title}</h3>
            <p className="text-sm text-gray-600">{description}</p>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default PageInfo;
